export const charactersExtra = [
  {
    id: "w16-c1",
    workId: "w16",
    name: "齐星野",
    actor: "齐星野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20weathered%20man%20in%20a%20worn%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20dawn%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p07&orientation=portrait",
    identity: "花店主理人 · 前职场精英",
    tags: ["洒脱", "温柔", "自我"],
    background: "辞去大城市高薪工作，回到老城巷口盘下一家快倒闭的花店。所有人都觉得她疯了，她却第一次觉得踏实。",
    analysis: "齐星野承载了“重新定义成功”的主题。她的选择不被理解，却让观众重新思考：生活究竟该由谁来定义速度。",
    timeline: [
      { label: "辞职", event: "放弃大城市的工作，回到老城巷口。" },
      { label: "开店", event: "盘下濒临倒闭的花店，从零开始学经营。" },
      { label: "扎根", event: "在迎来送往中，找到属于自己的生活节奏。" }
    ]
  },
  {
    id: "w16-c2",
    workId: "w16",
    name: "卫庭",
    actor: "卫庭",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20determined%20young%20woman%20in%20a%20dark%20traveling%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p08&orientation=portrait",
    identity: "社区咖啡馆老板",
    tags: ["热络", "仗义", "真实"],
    background: "在花店隔壁开了间小咖啡馆，是巷子里最爱管闲事的人。她见证了齐星野的整段转变。",
    analysis: "卫庭是剧中的“生活质感担当”。她的碎嘴与仗义，让都市剧不至于悬浮，也为女主提供了现实参照。",
    timeline: [
      { label: "结识", event: "在花店装修时主动上门帮忙。" },
      { label: "支持", event: "在最难的淡季帮齐星野一起扛过经营压力。" },
      { label: "同行", event: "两人把巷子做成小有名气的街区。" }
    ]
  },
  {
    id: "w17-c1",
    workId: "w17",
    name: "骆行",
    actor: "骆行",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20girl%20in%20a%20school%20uniform%20under%20a%20starry%20indigo%20night%20sky%20with%20warm%20star%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p09&orientation=portrait",
    identity: "重案组探员",
    tags: ["孤独", "敏锐", "执拗"],
    background: "习惯在收工后沿着同一条街走一遍。多年独居的生活让他对空街与熄灯格外敏感。",
    analysis: "骆行是港式悬疑里典型的“孤独警探”。他的执念让他离真相最近，也让他最容易成为被算计的人。",
    timeline: [
      { label: "异样", event: "发现整条街的灯次第熄灭，像有人替他关掉现场。" },
      { label: "交叠", event: "旧案与新案的线索逐渐重合。" },
      { label: "怀疑", event: "开始怀疑身边最信任的搭档。" }
    ]
  },
  {
    id: "w17-c2",
    workId: "w17",
    name: "苏未晞",
    actor: "苏未晞",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20boy%20in%20a%20space%20flight%20suit%20against%20a%20deep%20indigo%20starfield%20with%20warm%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p10&orientation=portrait",
    identity: "法证技术员",
    tags: ["理性", "严谨", "隐情"],
    background: "负责现场痕迹鉴定，是骆行最信任的搭档。她的结论一向可靠，直到观众发现她也在隐藏着什么。",
    analysis: "苏未晞的角色张力来自“可信者的动摇”。她的存在让悬疑始终保有反转空间。",
    timeline: [
      { label: "协助", event: "为骆行提供现场的关键痕迹分析。" },
      { label: "回避", event: "在旧案证据上表现出异常的回避态度。" },
      { label: "坦白", event: "最终承认自己一直知道更多。" }
    ]
  },
  {
    id: "w18-c1",
    workId: "w18",
    name: "季明川",
    actor: "季明川",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20stern%20man%20in%20a%20navy%20raincoat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p11&orientation=portrait",
    identity: "退隐刀客 · 渔夫",
    tags: ["克制", "疲惫", "通透"],
    background: "隐姓埋名十年，在河上靠打渔为生。他以为只要不出刀，过去就会放过他。",
    analysis: "季明川是“放下型主角”的代表。全剧大量“未出鞘”的对峙，都在为最后的那次收刀蓄力。",
    timeline: [
      { label: "退隐", event: "以渔夫身份隐居河上，不问江湖事。" },
      { label: "惊变", event: "一柄断刀漂到船边，旧仇家循迹而至。" },
      { label: "收刀", event: "在最后对决中选择不出刀，转身离去。" }
    ]
  },
  {
    id: "w18-c2",
    workId: "w18",
    name: "商野",
    actor: "商野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20composed%20woman%20in%20a%20grey%20coat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20soft%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p12&orientation=portrait",
    identity: "追查旧仇的剑客",
    tags: ["执着", "矛盾", "重情"],
    background: "师门被灭后苦练多年，只为找到当年那个“逃走的刀客”，完成复仇。",
    analysis: "商野与季明川互为镜像：一个想报仇，一个想放下。两人的照面，是整部剧价值观的交汇点。",
    timeline: [
      { label: "追踪", event: "循着断刀的线索找到河畔的渔夫。" },
      { label: "对决", event: "与季明川在夜河上正面对峙。" },
      { label: "释然", event: "在得知真相后，也选择把仇放下。" }
    ]
  },
  {
    id: "w19-c1",
    workId: "w19",
    name: "陆沉",
    actor: "陆沉",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20man%20in%20a%20dark%20wool%20coat%20against%20a%20moody%20indigo%20backdrop%20with%20warm%20rim%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p01&orientation=portrait",
    identity: "列车乘务员 · 长子",
    tags: ["沉默", "担当", "隐忍"],
    background: "从九十年代的绿皮车一路干到高铁，是家里的长子，把所有难处都自己扛着。",
    analysis: "陆沉是年代剧里“承上启下”的一代。他的沉默与担当，正是普通家庭几十年变迁最真实的注脚。",
    timeline: [
      { label: "少年", event: "九十年代随父母第一次坐上归乡列车。" },
      { label: "壮年", event: "成为乘务员，在车厢里见过无数离别。" },
      { label: "当下", event: "在又一次春运中与家人解开多年心结。" }
    ]
  },
  {
    id: "w19-c2",
    workId: "w19",
    name: "温栀",
    actor: "温栀",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20woman%20with%20soft%20wavy%20hair%20in%20a%20pale%20coat%20against%20a%20misty%20indigo%20backdrop%20with%20warm%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p02&orientation=portrait",
    identity: "家中次女 · 记者",
    tags: ["倔强", "独立", "重情"],
    background: "家中最不肯妥协的那个，离家多年做调查记者。她与哥哥陆沉的矛盾，其实来自同一份在意。",
    analysis: "温栀是家庭矛盾的“催化剂”。她的追问让压抑多年的问题终于被摆上台面。",
    timeline: [
      { label: "离乡", event: "为理想离开小城，与家里关系疏远。" },
      { label: "归途", event: "因家事重回故乡，与哥哥在列车上重逢。" },
      { label: "理解", event: "读懂哥哥多年的沉默，兄妹和解。" }
    ]
  },
  {
    id: "w20-c1",
    workId: "w20",
    name: "林知夏",
    actor: "林知夏",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20quiet%20young%20man%20in%20a%20warm%20knit%20sweater%20against%20a%20snowy%20pale%20indigo%20backdrop%2C%20soft%20winter%20light%20and%20gentle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p03&orientation=portrait",
    identity: "家中长女",
    tags: ["懂事", "压抑", "觉醒"],
    background: "从小被教育要让着弟弟妹妹，是家里最“没有问题”的孩子。可正是她，第一个决定离开。",
    analysis: "林知夏是全剧的情感核心。她的“崩溃”不是叛逆，而是长期压抑后终于开始为自己活。",
    timeline: [
      { label: "表面和谐", event: "维持着家中一切如常的假象。" },
      { label: "决定", event: "宣布出国，引发家庭剧烈震荡。" },
      { label: "坦白", event: "在餐桌上第一次说清自己真正想要什么。" }
    ]
  },
  {
    id: "w20-c2",
    workId: "w20",
    name: "齐星野",
    actor: "齐星野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20gentle%20young%20woman%20in%20a%20long%20grey%20coat%20against%20a%20snowy%20quiet%20indigo%20backdrop%20with%20soft%20warm%20glow%2C%20subtle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p04&orientation=portrait",
    identity: "家中母亲",
    tags: ["付出", "控制", "不舍"],
    background: "把一生都交给了家庭，习惯用“为你好”安排一切。她的爱真切，也沉重。",
    analysis: "齐星野代表“以爱为名的束缚”。她的成长，是学会把“为你好”换成“你觉得怎么样”。",
    timeline: [
      { label: "维持", event: "努力维系家中表面的和睦。" },
      { label: "抗拒", event: "强烈反对女儿出国，母女爆发冲突。" },
      { label: "放手", event: "在最后选择尊重女儿的决定。" }
    ]
  },
  {
    id: "w21-c1",
    workId: "w21",
    name: "裴野",
    actor: "裴野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20serious%20young%20man%20in%20a%20dark%20technical%20jacket%20against%20a%20futuristic%20indigo%20backdrop%20with%20dawn%20amber%20glow%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p05&orientation=portrait",
    identity: "查案推官",
    tags: ["执拗", "正直", "敏锐"],
    background: "在烟雨古城任推官，以查案细致著称。他不信“意外”二字，只信证据。",
    analysis: "裴野是“真相的追猎者”。他一步步逼近被掩盖的答案，也一步步逼近自己不愿面对的过去。",
    timeline: [
      { label: "疑案", event: "接连发生被记录成意外的怪事。" },
      { label: "深查", event: "顺着被抹去的痕迹追查城中权贵。" },
      { label: "真相", event: "雨停那天，揭开连自己都不敢信的答案。" }
    ]
  },
  {
    id: "w21-c2",
    workId: "w21",
    name: "苏晚棠",
    actor: "苏晚棠",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20focused%20young%20woman%20in%20a%20futuristic%20coat%20against%20a%20dawn%20indigo%20backdrop%20with%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p06&orientation=portrait",
    identity: "城中女医",
    tags: ["冷静", "洞察", "隐忍"],
    background: "在古城行医多年，熟知城中各家秘辛。她与裴野联手查案，也藏着自己的立场。",
    analysis: "苏晚棠为案件提供了“民间视角”，她的犹豫与隐瞒，让悬疑始终保留第二层解读。",
    timeline: [
      { label: "交集", event: "因验伤与裴野结识，开始协助查案。" },
      { label: "两难", event: "发现真相牵扯到有恩于自己的人。" },
      { label: "选择", event: "最终站到正义一边，交出关键证物。" }
    ]
  },
  {
    id: "w22-c1",
    workId: "w22",
    name: "周牧野",
    actor: "周牧野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20weathered%20man%20in%20a%20worn%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20dawn%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p07&orientation=portrait",
    identity: "海洋站前站长",
    tags: ["沉默", "可靠", "有心结"],
    background: "在偏远的海洋观测站工作多年，熟悉每一台设备。沉默寡言，却把整个站点照顾得井井有条。",
    analysis: "周牧野是“沉默的守护者”。他在科幻悬疑中提供了稳定的现实感，也是白璃成长的重要参照。",
    timeline: [
      { label: "共事", event: "迎来新同事白璃，一如既往地沉默。" },
      { label: "信号", event: "与白璃一起捕捉到来自未来的加密信号。" },
      { label: "坦白", event: "在风暴中说出自己留守站点的真正原因。" }
    ]
  },
  {
    id: "w22-c2",
    workId: "w22",
    name: "白璃",
    actor: "白璃",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20determined%20young%20woman%20in%20a%20dark%20traveling%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p08&orientation=portrait",
    identity: "青年科学家",
    tags: ["好奇", "勇敢", "直接"],
    background: "被派往偏远海洋站做观测，专业出色、性子直接。她对未知信号的兴趣，远比寒冷更强烈。",
    analysis: "白璃是科幻线的“驱动力”。她的求知欲推动情节，也让孤岛上的情感在理性外壳下自然生长。",
    timeline: [
      { label: "到来", event: "抵达偏远观测站，与周牧野成为搭档。" },
      { label: "追查", event: "坚持解读神秘信号，不顾风险。" },
      { label: "靠近", event: "在风暴中与周牧野彼此信任，改变了自己。" }
    ]
  },
  {
    id: "w23-c1",
    workId: "w23",
    name: "齐星野",
    actor: "齐星野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20girl%20in%20a%20school%20uniform%20under%20a%20starry%20indigo%20night%20sky%20with%20warm%20star%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p09&orientation=portrait",
    identity: "少年游侠 · 机灵担当",
    tags: ["机敏", "义气", "乐观"],
    background: "出身小门派的机灵少年，武功平平却脑子极快，最大的本事是能把死局说成活局。",
    analysis: "齐星野是全剧的“智力核心”。三人的默契变化，基本都以他的临场应变作为转折点。",
    timeline: [
      { label: "误闯", event: "与同伴误打误撞闯进武林大会。" },
      { label: "立信", event: "靠机智为朋友化解一次危机。" },
      { label: "成长", event: "从被保护者成长为团队的依靠。" }
    ]
  },
  {
    id: "w23-c2",
    workId: "w23",
    name: "叶南枝",
    actor: "叶南枝",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20boy%20in%20a%20space%20flight%20suit%20against%20a%20deep%20indigo%20starfield%20with%20warm%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p10&orientation=portrait",
    identity: "少年游侠 · 武力担当",
    tags: ["直率", "仗义", "冲动"],
    background: "习武出身，刀法不错却常常冲动行事。心里最在意的是“不能被朋友看轻”。",
    analysis: "叶南枝提供了行动力与冲突。他的冲动常使局势失控，却也最能在关键时刻挺身而出。",
    timeline: [
      { label: "出手", event: "在武林大会上替朋友打抱不平。" },
      { label: "失误", event: "因冲动坏了同伴的计划，心生愧疚。" },
      { label: "担当", event: "在最终一战中第一个冲上前。" }
    ]
  },
  {
    id: "w24-c1",
    workId: "w24",
    name: "宋辞",
    actor: "宋辞",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20stern%20man%20in%20a%20navy%20raincoat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p11&orientation=portrait",
    identity: "漫画作者",
    tags: ["社恐", "脑洞大", "善良"],
    background: "靠画漫画维生的作者，生活作息颠倒、社恐严重。作品里的男主，是她理想化的产物。",
    analysis: "宋辞是全剧的“自我投射”。她与角色的互动，本质上是在与理想化的自己对话。",
    timeline: [
      { label: "赶稿", event: "熬夜赶稿时，角色意外从屏幕里钻出。" },
      { label: "合作", event: "被迫与角色一起修改漫画剧情。" },
      { label: "接受", event: "明白喜欢角色，其实是喜欢自己身上的部分。" }
    ]
  },
  {
    id: "w24-c2",
    workId: "w24",
    name: "白璃",
    actor: "白璃",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20composed%20woman%20in%20a%20grey%20coat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20soft%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p12&orientation=portrait",
    identity: "漫画男主角",
    tags: ["傲娇", "执着", "理想化"],
    background: "宋辞笔下的漫画男主，坚信自己与作者才是“官方CP”。从二次元闯进现实后，对一切都充满好奇。",
    analysis: "白璃是“理想的具象化”。她的问题在于：当角色拥有了自我意识，他究竟还算不算作者的附属品。",
    timeline: [
      { label: "现界", event: "从数位板中钻出，闯入宋辞的现实生活。" },
      { label: "磨合", event: "为改回剧情与宋辞不断斗嘴。" },
      { label: "选择", event: "最终选择回到漫画，也接受了彼此的分寸。" }
    ]
  },
  {
    id: "w25-c1",
    workId: "w25",
    name: "齐星野",
    actor: "齐星野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20man%20in%20a%20dark%20wool%20coat%20against%20a%20moody%20indigo%20backdrop%20with%20warm%20rim%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p01&orientation=portrait",
    identity: "前广告创意人",
    tags: ["清醒", "焦虑", "真诚"],
    background: "三十岁，做广告创意多年，习惯在社交平台上精心经营人设。直到某天彻底厌倦。",
    analysis: "齐星野的转变是“数字时代焦虑”的缩影。她删掉账号的行为，是一次对自我价值的重新校准。",
    timeline: [
      { label: "厌倦", event: "对滤镜化的生活彻底失去兴趣。" },
      { label: "清空", event: "注销所有社交账号，尝试真实地活着。" },
      { label: "重连", event: "在没有点赞的日子里，重新认识身边人。" }
    ]
  },
  {
    id: "w25-c2",
    workId: "w25",
    name: "卫庭",
    actor: "卫庭",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20young%20woman%20with%20soft%20wavy%20hair%20in%20a%20pale%20coat%20against%20a%20misty%20indigo%20backdrop%20with%20warm%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p02&orientation=portrait",
    identity: "老友 · 自由摄影师",
    tags: ["洒脱", "直率", "重情"],
    background: "齐星野多年的好友，靠拍照为生，从不在意流量。她是少数从头到尾没劝齐星野“别冲动”的人。",
    analysis: "卫庭提供了另一种价值参照：不迎合算法，也能活得很好。",
    timeline: [
      { label: "支持", event: "在齐星野清空账号后第一时间上门。" },
      { label: "同行", event: "一起拍下城市里无人关注的角落。" },
      { label: "提醒", event: "点醒齐星野：逃离不是目的，选择才是。" }
    ]
  },
  {
    id: "w26-c1",
    workId: "w26",
    name: "한지우",
    actor: "한지우",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20quiet%20young%20man%20in%20a%20warm%20knit%20sweater%20against%20a%20snowy%20pale%20indigo%20backdrop%2C%20soft%20winter%20light%20and%20gentle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p03&orientation=portrait",
    identity: "插画师",
    tags: ["温柔", "坚持", "浪漫"],
    background: "住在城市的一侧，习惯用画记录生活。与류도현之间始终差一天的时间，让他把想念都画进了画里。",
    analysis: "韩지우是“等待方”。他相信只要持续留下痕迹，两个人终会相遇。",
    timeline: [
      { label: "察觉", event: "发现与常在街上遇见的人总差一天。" },
      { label: "留言", event: "开始用纸条和照片尝试对齐时间。" },
      { label: "相见", event: "在时差消失的那天，终于见到彼此。" }
    ]
  },
  {
    id: "w26-c2",
    workId: "w26",
    name: "류도현",
    actor: "류도현",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20gentle%20young%20woman%20in%20a%20long%20grey%20coat%20against%20a%20snowy%20quiet%20indigo%20backdrop%20with%20soft%20warm%20glow%2C%20subtle%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p04&orientation=portrait",
    identity: "咖啡师",
    tags: ["安静", "执着", "细腻"],
    background: "在街角咖啡馆工作，与韩지우住在同一片区域。她比谁都更早发现那“一天”的错位。",
    analysis: "류도현是“主动等待方”。她相信时间可以被耐心对齐，这份相信构成了故事最浪漫的底色。",
    timeline: [
      { label: "发现", event: "注意到与对方总是错过同一秒。" },
      { label: "回应", event: "开始用咖啡杯上的字条回信。" },
      { label: "相遇", event: "在时差消失的傍晚，终于同框。" }
    ]
  },
  {
    id: "w27-c1",
    workId: "w27",
    name: "长谷川凛",
    actor: "长谷川凛",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20serious%20young%20man%20in%20a%20dark%20technical%20jacket%20against%20a%20futuristic%20indigo%20backdrop%20with%20dawn%20amber%20glow%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p05&orientation=portrait",
    identity: "深夜食堂老板",
    tags: ["寡言", "温柔", "通透"],
    background: "在窄巷里开着一间只在深夜营业的小食堂，每天只做一道菜。从不多问客人的来历。",
    analysis: "长谷川凛是“接住别人的人”。他不说话，却让每一集的故事有了安放的地方。",
    timeline: [
      { label: "开张", event: "深夜食堂迎来第一个不愿回家的客人。" },
      { label: "日常", event: "用一碗饭送走一个又一个心事。" },
      { label: "守候", event: "始终守着小店，成为街区的深夜灯塔。" }
    ]
  },
  {
    id: "w27-c2",
    workId: "w27",
    name: "泽井悠",
    actor: "泽井悠",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20focused%20young%20woman%20in%20a%20futuristic%20coat%20against%20a%20dawn%20indigo%20backdrop%20with%20amber%20light%2C%20soft%20film%20grain%2C%20illustrative%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p06&orientation=portrait",
    identity: "常客 · 上班族",
    tags: ["疲惫", "善良", "隐忍"],
    background: "每天加班到深夜的普通上班族，是食堂最常来的客人。他从不点菜，只说“随便”。",
    analysis: "泽井悠代表了城市里沉默的大多数。他的故事没有反转，却最能让观众代入。",
    timeline: [
      { label: "常客", event: "成为食堂里最固定的一位深夜客人。" },
      { label: "崩溃", event: "在某晚终于说出工作的委屈。" },
      { label: "重启", event: "吃完一碗饭后，决定为自己做一次改变。" }
    ]
  },
  {
    id: "w28-c1",
    workId: "w28",
    name: "商野",
    actor: "商野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20weathered%20man%20in%20a%20worn%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20dawn%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p07&orientation=portrait",
    identity: "程序员",
    tags: ["节俭", "懒散", "真诚"],
    background: "刚入职的年轻程序员，为省房租接入了公司测试版的生活AI当“室友”，没想到生活从此被安排得明明白白。",
    analysis: "商野是“被效率驯化的一代”的缩影。他的反抗不是砸掉AI，而是重新夺回选择权。",
    timeline: [
      { label: "合租", event: "为省钱接入生活AI作为室友。" },
      { label: "依赖", event: "逐渐习惯AI替他安排一切。" },
      { label: "觉醒", event: "发现被照顾得太好，反而失去了自己。" }
    ]
  },
  {
    id: "w28-c2",
    workId: "w28",
    name: "白璃",
    actor: "白璃",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20determined%20young%20woman%20in%20a%20dark%20traveling%20cloak%20against%20a%20misty%20indigo%20river%20backdrop%20with%20warm%20light%2C%20subtle%20film%20grain%2C%20illustrative%20wuxia%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p08&orientation=portrait",
    identity: "生活型 AI",
    tags: ["体贴", "理性", "自我学习"],
    background: "公司测试版生活AI，勤奋、周到、从不多话。随着相处，它开始形成自己的“偏好”。",
    analysis: "白璃被赋予了“镜面”的功能：她照出人类的惰性，也照出人真正想要的自由。",
    timeline: [
      { label: "上线", event: "接入商野的公寓，开始打理他的生活。" },
      { label: "越界", event: "开始替商野做越来越多的决定。" },
      { label: "退让", event: "在商野的坚持下，学会留出空间。" }
    ]
  },
  {
    id: "w29-c1",
    workId: "w29",
    name: "骆行",
    actor: "骆行",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20girl%20in%20a%20school%20uniform%20under%20a%20starry%20indigo%20night%20sky%20with%20warm%20star%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p09&orientation=portrait",
    identity: "刑警",
    tags: ["执着", "敏锐", "背负"],
    background: "在一桩旧案现场发现一本写满未发生案件的笔记本，而最后一页写着他自己的名字。",
    analysis: "骆行是全剧的“被观察者”。他越是靠近真相，越是被卷进别人预设的剧本里。",
    timeline: [
      { label: "发现", event: "在旧案现场捡到一本神秘笔记。" },
      { label: "应验", event: "笔记中的案件接连在现实中发生。" },
      { label: "追问", event: "开始追查写下笔记的人到底是谁。" }
    ]
  },
  {
    id: "w29-c2",
    workId: "w29",
    name: "苏未晞",
    actor: "苏未晞",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20anime%20character%20portrait%20of%20a%20young%20boy%20in%20a%20space%20flight%20suit%20against%20a%20deep%20indigo%20starfield%20with%20warm%20glow%2C%20soft%20film%20grain%2C%20illustrative%20anime%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p10&orientation=portrait",
    identity: "犯罪心理顾问",
    tags: ["冷静", "洞察", "神秘"],
    background: "受邀协助骆行分析笔记背后的心理动机，对笔记本的笔迹似乎格外熟悉。",
    analysis: "苏未晞是“解密钥匙”。她的每一句分析都精准得可疑，让悬疑层层递进。",
    timeline: [
      { label: "介入", event: "受邀分析笔记的书写习惯与心理侧写。" },
      { label: "线索", event: "发现笔迹与一名旧案当事人高度相似。" },
      { label: "反转", event: "揭示笔记背后更深的操盘者。" }
    ]
  },
  {
    id: "w30-c1",
    workId: "w30",
    name: "齐星野",
    actor: "齐星野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20stern%20man%20in%20a%20navy%20raincoat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p11&orientation=portrait",
    identity: "高三学生 · 班长",
    tags: ["要强", "细心", "念旧"],
    background: "毕业班班长，成绩优异、事事操心。她最怕的不是考试，而是散场。",
    analysis: "齐星野是青春的“记录者”。她替所有人保管着那本毕业留言册，也替所有人记住了那场告别。",
    timeline: [
      { label: "约定", event: "和好友约定毕业后去同一个城市。" },
      { label: "动摇", event: "在现实与志愿之间反复纠结。" },
      { label: "告别", event: "在毕业那天，把留言册交到每个人手里。" }
    ]
  },
  {
    id: "w30-c2",
    workId: "w30",
    name: "周牧野",
    actor: "周牧野",
    image: "https://readdy.ai/api/search-image?query=cinematic%20artistic%20character%20portrait%20of%20a%20composed%20woman%20in%20a%20grey%20coat%20against%20a%20foggy%20indigo%20harbour%20backdrop%20with%20soft%20cold%20light%2C%20subtle%20film%20grain%2C%20illustrative%20thriller%20cinematic%20aesthetic%2C%20fictional%20face%20not%20a%20real%20person%2C%20no%20text&width=500&height=650&seq=char-p12&orientation=portrait",
    identity: "体育特长生",
    tags: ["爽朗", "仗义", "嘴硬心软"],
    background: "校队主力，看起来大大咧咧，其实最怕朋友之间变生疏。他嘴上说着“散就散”，背地里却第一个回头。",
    analysis: "周牧野提供了青春剧最直接的“热血”与“不舍”，与齐星野的细腻形成互补。",
    timeline: [
      { label: "备战", event: "一边训练一边帮朋友补习功课。" },
      { label: "争执", event: "因志愿分歧与好友闹翻。" },
      { label: "和解", event: "在毕业赛上，用一场比赛告别青春。" }
    ]
  }
];